import { useContext } from 'react';

import { UserContext, Context } from 'utils/UserContext';

export const useCurrentUser = (): Context => useContext(UserContext);
